<template>
  <div class="room pressure-fan" v-loading="loading">
    <refresh-block @refreshData="refreshData"></refresh-block>
    <div class="pressure-fan-item" v-for="(item,$index) in deviceList" :key="$index">
      <div class="fan-chart">
        <div class="fan-chart-warp fan-bg" :class="deviceStatus1(item[0].deviceId,item[2].deviceId)">
          <single-ring :opts="SingleRingOpts" :series="temAir(item[0].deviceId,item[2].deviceId)"></single-ring>
        </div>
        <div class="fan-chart-warp fan-bg" :class="deviceStatus2(item[1].deviceId)">
          <single-histogram :opts="singleHisOpts" :series="pressure(item[1].deviceId)"></single-histogram>
        </div>
      </div>
      <div class="fan-switch">
        <switch-status :title="`高压风机${$index+1}# 风机过载`" :series="switchStatus(item[3].deviceId)"></switch-status>
      </div>
    </div>
  </div>
</template>
<script>
  import pressureFanJson from './pressureFan.json'

  export default {
    name: 'pressureFan',
    data() {
      return {
        loading: false,
        singleHisOpts: { title: '压力', histogramName1: 'kPa', max: 10000 },
        SingleRingOpts: { title: '出口温度&流量', labelLineLength: 1, center: ['50%', '60%'], data1Max: 80, data2Max: 200 },
        stationList: {
          pressureFanFive: '464f8e80-e525-45b4-885c-e07940e237d2', // 5#制备站高压风机
          pressureFanSix: '7618ff66-8e69-49e0-ac8d-d5dc424b1879' // 6#制备站高压风机
        },
        deviceList: [],
        deviceObject: {},
        routeName: '',
        timeFunc: null,
      }
    },
    watch: {
      /**
       * 监听路由变化
       * @param {Object} route # 当前路由信息
       */
      '$route'(route) {
        this.initData(route)
      }
    },
    created() {
      this.initData(this.$route)
      this.timeFunc = setInterval(() => {
        this.initData(this.$route)
      }, this.REFRESH_SECOND)
    },
    destroyed() {
      clearInterval(this.timeFunc)
      this.timeFunc = null
    },
    methods: {
      refreshData() {
        this.initData(this.$route)
        clearInterval(this.timeFunc)
        this.timeFunc = setInterval(() => {
          this.initData(this.$route)
        }, this.REFRESH_SECOND)
      },
      /**
       * 返回设备状态
       * @param {String}  id1 # 温度id
       * @param {String}  id2 # 湿度id
       * @return {String} ''
       */
      deviceStatus1(id1, id2) {
        let errorLevel = 'Normal'
        let errorLevel1 = (this.deviceObject[id1] || {}).errorLevel
        let errorLevel2 = (this.deviceObject[id2] || {}).errorLevel
        if (errorLevel1 !== errorLevel) errorLevel = errorLevel1
        if (errorLevel2 === 'Error') errorLevel = 'Error'
        return errorLevel
      },
      /**
       * 返回设备状态
       * @param {String}  id # 设备id
       * @return {String} ''
       */
      deviceStatus2(id) {
        return (this.deviceObject[id] || {}).errorLevel
      },
      /**
       * 返回高压风机状态
       * @param {String}  deviceId # 设备id
       * @return {Object} {}
       */
      switchStatus(deviceId) {
        return {
          data: (this.deviceObject[deviceId] || {}).value || 0,
          isZh: true,
          isError: (this.deviceObject[deviceId] || {}).errorLevel,
        }
      },
      /**
       * 返回温度和湿度
       * @param {String}  id1 # 温度id
       * @param {String}  id2 # 湿度id
       * @return {Object} {}
       */
      temAir(id1, id2) {
        return { data1: (this.deviceObject[id1] || {}).value, data2: (this.deviceObject[id2] || {}).value }
      },
      /**
       * 返回 压力
       * @param {String}  deviceId # 设备id
       * @return {Object} {}
       */
      pressure(deviceId) {
        return { data: (this.deviceObject[deviceId] || {}).value }
      },
      /**
       * 加载数据
       * @param {Object} route # 当前路由信息
       */
      initData({ name }) {
        this.loading = true
        if (this.routeName !== name) {
          this.routeName = name
          this.deviceList = pressureFanJson[name]
        }
        this.$http.get('/deviceData/Station?stationId=' + this.stationList[name])
          .then(({ data = {} }) => {
            this.$store.commit('setLastRefreshTime')
            this.loading = false
            this.deviceObject = data
          })
      },
      getData() {
        if (!this.loading) this.initData(this.$route)
      }
    }
  }
</script>
<style lang="scss" scoped>
  .pressure-fan {
    display: flex;
    align-content: space-between;
    justify-content: space-between;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 10px 0;
  }

  .pressure-fan-item {
    width: calc(33.3333% - 13.2222px);
    height: calc(50% - 20px);
    display: flex;
    flex-direction: column;
    align-content: space-between;
    justify-content: space-between;
  }

  .fan-switch {
    height: 42px;
  }

  .fan-chart {
    height: calc(100% - 52px);
    flex-direction: row;
    display: flex;
    justify-content: space-between;
  }

  .fan-chart-warp {
    width: calc(50% - 5px);
    height: 100%;
  }

  .fan-bg {
    background-color: rgba(255, 255, 255, 0.6);
  }
</style>
